import React from 'react';
import Immutable from 'immutable';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  NewsletterSignup,
} from '../../../components';

import './style.scss';

const ParagraphNewsletter = ({ id }) => {
  return (
    <div id={id} className="ParagraphNewsletter">
      <Container>
        <div className="row">
          <div className="ParagraphNewsletter__wrapper col-12">
            <NewsletterSignup />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphNewsletter;
